var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcOutlineChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.53 16.53a.75.75 0 0 1-1.06 0l-7-7a.75.75 0 0 1 1.06-1.06L12 14.94l6.47-6.47a.75.75 0 1 1 1.06 1.06l-7 7Z",
  fill: "#0C1120"
})));
export default SvgIcOutlineChevronDown;